/**
 * PF Revamp — catalogue category constants.
 *
 * Centralised here so selectors and any future consumer can import from
 * one place without duplicating the hardcoded id set.
 *
 * The set is keyed on category slugs, so a new on-site category is missed until it is added here;
 * the backend's instruction options correct the meeting requirement once they arrive.
 *
 * Current mapping:
 *   'on_site_capture' — photographed at the property (requires on-site meeting).
 */

/**
 * Set of `CatalogueCategory.id` slugs that require an on-site shooting visit.
 * Used by `selectDefaultScheduledByCT` and `selectSummaryStepValid` to gate
 * the meeting-scheduling requirement.
 */
export const ONSITE_SHOOTING_CATEGORY_IDS: ReadonlySet<string> = new Set([
  'on_site_capture',
])
